export const errorMap = {
  lockedAccount: 'User account is locked',
  noFederatedUser: 'There is no mapped federated user',
  noAdminRole: "You don't have admin role",
  notAuthorized:
    'You are not authorized to use this method of login. Please, return to previous page and try to login with your Envista account.',
}
